import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {environment} from "../../environments/environment";
import Pagination from "../../model/pagination";
import QueryEncoder from "../queryEncoder";
import {catchError, switchMap} from "rxjs/operators";
import CompanyModel from "../../model/company.model";

@Injectable()
export default class CompanyService {
    public constructor(private http: HttpClient) {
    }

    public show(id: number): Observable<CompanyModel> {
        return this.http.get<CompanyModel>(environment.apiUrl + '/companies/' + id);
    }

    public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additional?: any): Observable<Pagination<CompanyModel>> {
        if(typeof query !== 'string') {
            query = '';
        }
        query = query || '';
        page = page || 1;
        limit = limit || 15;
        sort = sort || '';

        let sorting = {};
        sorting[sort] = direction;

        let q = {query, page, limit, sorting};

        if(additional) {
            Object.assign(q, additional);
        }

        return this.http
            .get<Pagination<CompanyModel>>(environment.apiUrl + '/companies?' + QueryEncoder.encodeURI(q));
    }

    public delete(company: CompanyModel): Observable<any> {
        return this.http.delete(environment.apiUrl + '/companies/' + company.id);
    }

    public update(company: CompanyModel): Observable<boolean> {
        return this.http.put(environment.apiUrl + '/companies/' + company.id, company).pipe(
            switchMap(r => of(true)),
            catchError(e => of(false))
        );
    }

    public create(company: CompanyModel): Observable<CompanyModel> {
        return this.http.post<CompanyModel>(environment.apiUrl + '/companies', company);
    }
}
